import { useMediaQuery } from 'designSystem/components/useMediaQuery'
import { MOBILE_LAYOUT_QUERY } from 'utils/mobileLayout'

export function useIsMobile() {
  return useMediaQuery(MOBILE_LAYOUT_QUERY)
}
